import { useEffect } from 'react';

export function AllowBodyScrolling() {
  useEffect(() => {
    if (window.location.pathname.indexOf('/mythic-plus-runs/') === -1) {
      // we only want to enable body scrolling for certain routes
      return;
    }

    const body = document.getElementById('rio-body');
    if (body) {
      body.style.overflowY = 'scroll';
      return () => {
        body.style.overflowY = 'hidden';
      };
    }
  }, []);

  return null;
}
